import React from 'react';

export const CloseIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 14 14" {...props}>
        <path
            fill="currentColor"
            stroke="currentColor"
            d="M13.177 2.177a.25.25 0 000-.354l-1-1a.25.25 0 00-.354 0L7 5.646 2.177.823a.25.25 0 00-.354 0l-1 1a.25.25 0 000 .354L5.646 7 .823 11.823a.25.25 0 000 .354l1 1a.25.25 0 00.354 0L7 8.354l4.823 4.823a.25.25 0 00.354 0l1-1a.25.25 0 000-.354L8.354 7l4.823-4.823z"
        />
    </svg>
);
